var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b4b4b",
      stroke: "none"
    },
    d: "M0 0L0 24L24 24L24 2L12 10L13 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M13 0L13 6L14 6L13 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M23 0L24 1L23 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M22 1L23 2L22 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M23 1L24 2L23 1M21 2L15 9L21 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M19 3L20 4L19 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M18 4L19 5L18 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M17 5L18 6L17 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M16 6L17 7L16 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M15 7L14 9L15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M13 8L14 9L13 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M12.6667 9.33333L13.3333 9.66667L12.6667 9.33333z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsw);
export default __webpack_public_path__ + "static/media/csw.b76f41cfcc1d27d1b5d57aaf1ce7063f.svg";
export { ForwardRef as ReactComponent };